module.exports = __webpack_public_path__ + "static/media/invite.1e2c8bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/invite.png
// module id = 1049
// module chunks = 0